import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { Grid } from '@material-ui/core';
export const StyledDivIntelligentCloseUpImageContainer = styled('div') `
	padding-bottom: ${Magnetic.spacer24};
	position: relative;
	overflow: auto;
	margin: ${Magnetic.spacer12} 0 ${Magnetic.spacer24} 0;
`;
export const StyledDivDefaultIntelligentCloseUpImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 360px;
    width: 100%;
    display: flex;
	margin-bottom:-5px;
	margin-left:-3px;
`);
export const StyledIntelligentCloseUpContent = styled('div') `
	text-align: justify;
	width: 100%;
`;
export const StyledIntelligentButtonContainer = styled('div') `
	position: absolute;
	display: flex;
	width: 100%;
	bottom: 0;
	justify-content: center;
`;
export const StyledIntelligentDivButtonInnerContainer = styled('div') `
	width: 320px;
	display: flex;
	justify-content: space-between;
	margin: 0px 22px;
`;
export const StyledIntelligentCameraImage = styled('div', {
    shouldForwardProp: prop => prop !== 'backgroundImage'
}) `
	background-image: url(${props => props.backgroundImage});
	width: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-repeat: no-repeat;
	border-radius: 50%;
	background-size: cover;
	background-position: center;
`;
const StyleDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 50px;
	height: 50px;
	outline: ${Magnetic.buttonFlatBorder};
	border-radius: 100%;
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyledIntelligentCloseUpImageButton = styled('button', {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	${StyleDivBaseImage}	
	background-color: ${props.backgroundColor};
	color: ${Magnetic.colorWhite};
`);
export const StyledCameraTextLabel = styled.div `
	color: #929292;
	font-size: ${Magnetic.fontSize12};
	text-align: center;
`;
//# sourceMappingURL=IntelligentCloseUpShotComponent.style.js.map